import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { useAppSelector } from '@/shared/hooks';

import { billingModel } from '@/entities/billing';

import { InventoryItemView } from '@/features/inventoryItemView';

import { BillingPeriod } from '../BillingPeriod/BillingPeriod.tsx';
import { NoSubscription } from '../NoSubscription/NoSubscription.tsx';

import styles from './Packages.module.scss';

type PackagesProps = {
  className?: string;
  testID?: string;
};

export const Packages: FC<PackagesProps> = (props) => {
  const { className, testID } = props;

  const { formatMessage } = useIntl();

  const packages = useAppSelector(billingModel.selectors.selectCurrentPackages);

  return (
    <div
      data-testid={testID}
      className={cn(styles.container, className)}
      data-section="subscription-packages"
    >
      <header className={styles.header}>
        <h4 className="h4">
          {formatMessage({
            id: 'subscription.packages.header',
            defaultMessage: 'Packages',
          })}
        </h4>
      </header>

      {packages?.length > 0 ? (
        <div>
          {packages.map((packageItem) => (
            <div key={packageItem.ID} className={styles.innerContainer}>
              <InventoryItemView inventoryItem={packageItem} />

              <BillingPeriod
                startDate={packageItem?.Start?.toDate() as Date}
                endDate={packageItem?.End?.toDate() as Date}
              />
            </div>
          ))}
        </div>
      ) : (
        <NoSubscription
          text={formatMessage({
            id: 'subscription.packages.noPackages',
            defaultMessage: 'No purchased packages yet',
          })}
        />
      )}
    </div>
  );
};
